import { twMerge } from 'tailwind-merge'

type SeparatorProps = {} & React.ComponentPropsWithoutRef<'span'>

export default function Separator({ className }: SeparatorProps) {
  className = twMerge('relative border-l min-h-5', className)

  return <span className={className} />
}
